<template>
  <router-link tag="div" :to="`/advisory/detail?id=${data.id}&catid=${data.catid}`" class="mr-advisory">
    <div class="content"><strong>{{ data.subtitle }}</strong></div>
    <div v-if="data.dirname === 'image' && data.peitu.length === 1" class="img">
      <img v-show="data.peitu[0] && data.peitu[0].attachment" v-lazy="data.peitu[0] && data.peitu[0].attachment" alt="">
    </div>
    <div v-else-if="data.dirname === 'video'" class="video">
      <mr-video class="mr-video" :src="data.url" :poster="data.peitu[0] && data.peitu[0].attachment"></mr-video>
    </div>
    <div v-if="data.dirname === 'image' && data.peitu.length > 1" class="multiple-img">
      <img v-for="(img, idx) in data.peitu" :key="idx" v-lazy="img.attachment" alt="">
    </div>
    <div class="content">
      <!-- <strong>{{ data.title }}</strong> -->
      <p v-if="data.description" class="color-B7BDCA fs-14 mt-10 van-multi-ellipsis--l2">{{ data.description }}</p>
    </div>
    <div class="footer">
      <span><span v-if="data.author">{{ data.author }}</span></span>
      <span class="flex align-center">{{ data.createtime * 1000 | formatTime }}</span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'MrAdvisory',
  props: {
    data: {
      type: Object,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>

.mr-advisory{
  box-shadow: 0 0 5px 0 #e5e5e5;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px 0;
  .img{
    width: 100%;
    height: 200px;
    border-radius: 5px;
    overflow: hidden;
    img{
      object-fit: cover;
      width: inherit;
      height: inherit;
    }
  }
  .multiple-img{
    height: 70px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    overflow: hidden;
    img{
      width: 33.33%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px;
      &:not(:last-child){
        border-right: 1px solid #fff;
      }
    }
  }
  .video{
    width: 100%;
    height: 200px;
    border-radius: 5px;
    background-color: #000000;
    .mr-video{
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .content, .footer{
    padding: 0 10px;
    margin: 10px 0;
  }
  .content{
    font-size: 18px;
    line-height: 24px;
    color: #0D0E15;
  }
  .footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #B7BDCA;
    font-size: 12px;
  }
}
</style>
